<app-top-bar></app-top-bar>
<main class="main-content">
  <router-outlet></router-outlet>
</main>


